import React from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import { Box, CircularProgress, List } from '@mui/material';
import { useSelector } from 'react-redux';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { handleDownloadAndViewDocument } from '../../../../utils/DownloadAndViewDocument';
import CustomTypography from '../../../../components/mui/CustomTypography';

import no_data_img from '../../../../assets/images/no-data-img.svg';
import CustomModal from '../../../../components/mui/CustomModal';
import { CustomButton } from '../../../../components/mui/CustomButton';

const DocumentsOptionModal = ({ open, onClose }) => {
  let editorDocmentData = useSelector((state) => state?.editorDocument?.user?.data?.value);
  let loadingDocument = useSelector((state) => state?.editorDocument?.loading);
  let docmentData = editorDocmentData && JSON.parse(editorDocmentData);
  return (
    <CustomModal open={open} onClose={onClose} dialogClassName="custom-modal">
      <div>
        <div className="preview-dropdown-header">
          Resources
          <HighlightOffRoundedIcon
            onClick={onClose}
            sx={{
              cursor: 'pointer',
              opacity: 0.5,
              height: '28px',
              width: '28px',
            }}
          />
        </div>
        <div className="preview-dropdown-body">
          {loadingDocument ? (
            <Box sx={{ textAlign: 'center', my: 5 }}>
              <CircularProgress
                sx={{
                  color: '#000000',
                }}
              />
            </Box>
          ) : (
            <>
              {((docmentData?.FileGuideDocuments.length === 0 && docmentData?.ProjectGuideDocuments.length === 0) ||
                (docmentData?.FileGuideDocuments === undefined &&
                  docmentData?.ProjectGuideDocuments === undefined)) && (
                <Box
                  sx={{
                    textAlign: 'center',
                    my: 1,
                  }}
                >
                  <img src={no_data_img} alt="no_data_img" />
                  <CustomTypography size="large" weight="medium" sx={{ margin: '24px 0' }}>
                    No Documents Available to Download
                  </CustomTypography>
                  <CustomButton variant="secondary" size="large" onClick={onClose}>
                    Done
                  </CustomButton>
                </Box>
              )}
              {docmentData?.FileGuideDocuments.length !== 0 &&
                docmentData?.FileGuideDocuments !== null &&
                docmentData?.FileGuideDocuments !== undefined && (
                  <Box sx={{ borderBottom: '1px solid #ccc', mb: 2, py: 2 }}>
                    <CustomTypography weight="medium">File Guides</CustomTypography>
                    <List sx={{ mb: 2, mt: 2 }}>
                      {docmentData?.FileGuideDocuments.map((data, index) => {
                        return (
                          <Box
                            sx={{
                              display: 'flex',
                              marginBottom: 1,
                            }}
                            key={index}
                          >
                            <Box sx={{ flex: 1 }}>
                              <CustomTypography size="mediumSmall" weight="medium" style={{ opacity: 0.7 }}>
                                {index + 1}. {data?.DocumentName}
                              </CustomTypography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                              <Box
                                className="fileDownloadicon"
                                onClick={() =>
                                  handleDownloadAndViewDocument({
                                    pathName: data?.FilePath,
                                    fileName: data?.DocumentName,
                                  })
                                }
                              >
                                <FileDownloadOutlinedIcon />
                              </Box>
                            </Box>
                          </Box>
                        );
                      })}
                    </List>
                  </Box>
                )}
              {docmentData?.ProjectGuideDocuments.length !== 0 &&
                docmentData?.ProjectGuideDocuments !== null &&
                docmentData?.ProjectGuideDocuments !== undefined && (
                  <Box sx={{ borderBottom: '1px solid #ccc', mb: 2, py: 2 }}>
                    <CustomTypography weight="medium">Project Guides</CustomTypography>
                    <List sx={{ mb: 2, mt: 2 }}>
                      {docmentData?.ProjectGuideDocuments.map((data, index) => {
                        return (
                          <Box
                            sx={{
                              display: 'flex',
                              marginBottom: 1,
                            }}
                            key={index}
                          >
                            <Box sx={{ flex: 1 }}>
                              <CustomTypography
                                size="mediumSmall"
                                weight="medium"
                                style={{ opacity: 0.7, fontWeight: 500 }}
                              >
                                {index + 1}. {data?.DocumentName}
                              </CustomTypography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                              <div
                                className="fileDownloadicon"
                                onClick={() =>
                                  handleDownloadAndViewDocument({
                                    pathName: data?.FilePath,
                                    fileName: data?.DocumentName,
                                  })
                                }
                              >
                                <FileDownloadOutlinedIcon />
                              </div>
                            </Box>
                          </Box>
                        );
                      })}
                    </List>
                  </Box>
                )}
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default DocumentsOptionModal;
